import { AlertTriangle } from "lucide-react";

export default function ComingSoonBanner() {
  return (
    <div
      data-testid="coming-soon-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-[#FFCC00] text-black"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2 flex items-center gap-3 text-[11px] md:text-xs font-semibold uppercase tracking-[0.18em]">
        <AlertTriangle size={14} className="shrink-0" />
        <span className="truncate">
          CLB Solution LLC is preparing for launch — Training programs, district support &amp; digital tools rolling out in phases.
        </span>
        <a
          data-testid="coming-soon-contact-link"
          href="mailto:clbsolutionllc@gmail.com"
          className="ml-auto hidden md:inline border-b border-black/40 hover:border-black"
        >
          clbsolutionllc@gmail.com
        </a>
      </div>
    </div>
  );
}
